import {
  HookFormAutocomplete,
  HookFormDatePicker,
  HookFormCheckbox,
  HookFormInput,
  HookFormSelect,
  HookFormTeamTypeAutocomplete,
  HookFormTeamAutocomplete,
  HookFormProductionRunAutocomplete,
  HookFormAutocompleteMultiple,
  HookFormTableInput,
  HookQuerySearchSelect,
  UseGetQueryDef,
} from 'ui-component/HookFormComponents/index';
import { BasePackageAutocompleteInlineEdit } from 'ui-component/HookFormComponents/InlineEditInputComponents/components/BasePackageAutocompleteInlineEdit';
import { HookFormAddressSelect } from 'ui-component/HookFormComponents/HookFormAddressSelect';
import { HookFormUserAutocomplete } from 'ui-component/HookFormComponents/HookFormUserAutocomplete';
import HookFormTagsAutocomplete from 'ui-component/HookFormComponents/HookFormTagsAutocomplete';
import { HookFormQuillInput } from 'ui-component/HookFormComponents/HookFormQuillInput';
import { quoteLineFormConstants } from 'ui-component/supplierQuotes/QuoteLineForm';
import { Control } from 'react-hook-form';

// To be used with renderEditCellWithInput, which is used for inline editing cells in a Datagrid

export const EditInlineStringInput = (
  <HookFormInput
    onKeyDown={(event) => {
      if (event.key === 'Enter') {
        event.stopPropagation();
      }
    }}
    disableRequiredProps
  />
);

export const EditInlineProductionRunAutocomplete = (
  <HookFormProductionRunAutocomplete
    disableRequiredProps
    isInlineEdit
    setValue={() => {}}
  />
);

export const EditInlineNumberInput = (
  <HookFormInput
    onKeyDown={(event) => {
      if (event.key === 'Enter') {
        event.stopPropagation();
      }
    }}
    inputProps={{
      inputMode: 'decimal',
      pattern: '[0-9]*[.]?[0-9]*',
      max: 1000000000,
      min: 0,
      step: 'any',
    }}
    type="number"
    disableRequiredProps
  />
);

export const EditInlineDatePicker = (
  <HookFormDatePicker
    onKeyDown={(event) => {
      if (event.key === 'Enter') {
        event.stopPropagation();
      }
    }}
    disableRequiredProps
    clearable
  />
);

/**
 * To use EditInlineSelect, EditInlineMultipleSelect, or EditInlineAutocomplete, you'll need to also pass in additionalInputElementProps with options
 * Example:
 * additionalInputElementProps: {
 *  options: [
 *      { value: 'option1', label: 'Option 1' },
 *      { value: 'option2', label: 'Option 2' },
 *  ],
 * },
 */
export const EditInlineSelect = <HookFormSelect disableRequiredProps />;

export const EditInlineMultipleSelect = (
  <HookFormSelect disableRequiredProps multiple />
);

export const EditInlineAutocomplete = (
  <HookFormAutocomplete disableRequiredProps mb={0} />
);

export const EditInlineAutocompleteMultiple = (
  <HookFormAutocompleteMultiple disableRequiredProps options={[]} />
);

export const EditInlinePackageAutocomplete = (
  <BasePackageAutocompleteInlineEdit disableRequiredProps />
);

export const EditInlineAddressSelect = (
  <HookFormAddressSelect disableRequiredProps />
);

// TODO: Fix button saving styling for this or add a border or something
export const EditInlineCheckbox = <HookFormCheckbox disableRequiredProps />;

export const EditInlineTeamTypeAutocomplete = (
  <HookFormTeamTypeAutocomplete disableRequiredProps isInlineEdit />
);

export const EditInlineTeamAutocomplete = (
  <HookFormTeamAutocomplete disableRequiredProps isInlineEdit />
);

export const EditInlineUserAutocomplete = (
  <HookFormUserAutocomplete disableRequiredProps isInlineEdit />
);

export const EditInlineTagsAutocomplete = (
  <HookFormTagsAutocomplete disableRequiredProps isInlineEdit />
);

export const EditInlineHookQuerySearchSelect = (
  <HookQuerySearchSelect
    disableRequiredProps
    schema={[]}
    useGetQuery={(() => {}) as UseGetQueryDef<any>}
    getOptionLabel={() => ''}
    control={{} as Control}
    name=""
  />
);

export const EditInlineQuillInput = (
  <HookFormQuillInput disableRequiredProps hideLabel />
);

export const EditInlinePriceBreaksInput = (
  <HookFormTableInput
    name=""
    control={{} as Control}
    errors={{}}
    fields={[
      {
        component: HookFormInput,
        name: quoteLineFormConstants.from.id,
        label: quoteLineFormConstants.from.label,
        props: {
          InputProps: {
            endAdornment: 'pcs',
          },
        },
      },
      {
        component: HookFormInput,
        name: quoteLineFormConstants.unitPrice.id,
        label: quoteLineFormConstants.unitPrice.label,
        props: {
          InputProps: {
            startAdornment: '$',
          },
        },
      },
    ]}
  />
);
